export default __webpack_public_path__ + "static/media/bookmark.1f8d0059.svg";